function t(n,i,r){return typeof n=="string"?n.slice(i,r):e=>e.slice(n,i)}export{t as a};
